<template>
    <div class="w-full">
        <div>
            <p class="text-left mx-8 mt-4">
                Please provide details of any English Language tests you have completed. This will ensure that the Admissions Team
                has all information to hand and are able to assess your application quickly.
            </p>
        </div>
        <div class="w-full text-left pl-8 pt-4">* Required fields</div>
        <div class="text-left mx-8 mt-4 mb-4">
            <input id="declaration-check" v-model="noEnglishTest" type="checkbox" name="noEnglishTest" @click="noEnglishTest = !noEnglishTest" />
            <label for="noEnglishTest" class="ml-2 text-right"><strong>I haven't completed an English Language Test</strong></label>
        </div>
        <div v-if="successMessage" class="mx-8 mb-4 success-message">{{ successMessage }}</div>
        <div v-if="serverError" class="mx-8 mb-4 server-error">{{ serverError }}</div>
        <div v-if="!noEnglishTest" class="p-4">
            <div v-for="(testResult, index) in englishTests" :key="index" class="w-full">
                <div>
                    <english-test-form
                        :application-reference="applicationReference"
                        :test-result="testResult"
                        :item-index="index"
                        @delete="removeEnglishTest"
                    />
                </div>
            </div>

            <div v-if="testCount < 5">
                <button class="btn-green mb-8" @click="newEnglishTest">Add <span v-if="testCount > 0">other</span> english test result</button>
            </div>
        </div>
        <div v-else class="text-left ml-8 relative">
            <button class="btn-green mb-8 w-40" @click="saveNoEnglishTest">Save</button>
            <div v-if="loading" class="lds-ring-container absolute top-2 left-2">
                <div class="lds-ring"><div /><div /><div /><div /></div>
            </div>
        </div>
    </div>
</template>

<script>
import EnglishTestForm from './EnglishTestForm.vue'

export default {
  components: {EnglishTestForm},
  props: {
    applicationReference: String,
    testResults: Array,
    noEnglishTestTaken: Number,
  },
  data() {
    return {
      englishTests: this.testResults,
      formDirty: false,
      loading: false,
      noEnglishTest: this.noEnglishTestTaken === 1,
      successMessage: '',
      serverError: '',
    }
  },
  computed: {
    testCount() {
      return this.englishTests.length
    },
  },
  mounted() {
    if (this.englishTests.length === 0){
      this.newEnglishTest()
    }
  },
  methods: {
    newEnglishTest() {
      this.englishTests.push({
        reference: null,
        testTaken: null,
        reportFormNumber: null,
        testDate: null,
        listeningResult: null,
        readingResult: null,
        writingResult: null,
        speakingResult: null,
        overallResult: null,
        notes: null,
      })
    },
    removeEnglishTest(index) {
      this.englishTests.splice(index, 1)
    },
    saveNoEnglishTest() {
      this.loading = true
      this.$store.dispatch('noEnglishTestTaken', {
        applicationReference: this.applicationReference,
      }).then(response => {
        this.loading = false
        this.successMessage = response.data
        this.serverError = ''
        window.location.search += '&section=englishTestShow'
      }).catch(error => {
        this.loading = false
        this.successMessage = ''
        this.serverError = error.response.data
      })
    },
  },
}
</script>